export const BostonData = [
  {
    title: "Life Sciences",
    detail:
      "The maritime trade industry's translation services could provide a way to expand to new markets beyond Boston. Meanwhile, our biotech translators are equipped with knowledge of the best technological and language solutions for your needs. Our medical translation services in Boston provide interpreting services for both virtual and physical doctor's visits, as well as translation services for all medical documents.",
    link: "/industries/healthcare",
  },
  {
    title: "Legal",
    detail:
      "Our legal translation services provide legal translators for your business needs, including affidavits, contracts, articles of incorporation, and more. They go through a rigorous vetting process, and must have the experience and knowledge for their industry. Legal translators are sought after for their linguistic prowess, too. If you need notarized translation services, legal translators can provide both notarized translations and certified translations.",
    link: "/legal-translation.php",
  },
  {
    title: "Technical",
    detail:
      "Are you looking for technical translation services? At Tomedes, we treat technical translations as a highly specialized field for which the technical translator must be fully knowledgeable. Our technical translators have a background in the technical field in order to translate technical terminologies. They also have linguistic mastery of two or more languages, in order to be accurate and specific and provide quality translation. For entry into new markets, the technical industry in Boston can benefit from our translators' expertise.",
    link: "/technical-translation.php",
  },
  {
    title: "Finance",
    detail:
      "In Boston, translation services for finance are hard to come by. At Tomedes, our financial translators are sought after for the financial translation services they've mastered. Our financial translators can translate financial documents such as asset documents, or localize financial apps. Their expertise covers a range of departments from FinTech to digital banking to cryptocurrency. You wouldn't want a medical translator translating your financial documents. So choose Tomedes today.",
    link: "/financial-translation.php",
  },
  {
    title: "Information Technology (IT)",
    detail:
      "In Boston, translation of IT documents, localization of IT applications, and more can all be done by Tomedes. Our IT translation service has the skill set made for Boston, be it in linguistic rigor or in IT industry standards. Information technology has a specific set of terminologies that's applicable for only IT alone. However, our IT translators can handle any terminology from one language to another, using options for machine translation post editing when requested.",
    link: "/industries/technology",
  },
];

export const LanguagesInBoston = [
  {
    heading: "Portuguese",
    detail:
      "Portuguese is the first or second language of most Boston residents, with about a million residents speaking Portuguese in Boston, a new study shows. If you need Portuguese to English translation, or a second language, choose from over 128 languages and 950+ language pairs.",
    link: "/portuguese-translation.php",
  },
  {
    heading: "Spanish",
    detail:
      "After Portuguese, Spanish is the most common non-English language spoken in Boston, Massachusetts. 9.41% of the overall population of Massachusetts are native Spanish speakers. If you're looking to connect with this demographic, you may have to find the best translation services for this endeavor. So why not contact Tomedes?",
    link: "/spanish-translation.php",
  },
  {
    heading: "Russian",
    detail:
      "There are 18,784 Russian-born residents in Boston, Massachusetts. That makes Russian one of the more major minority languages. If you're seriously considering entering a Russian speaking market, you may get lost in translation. Find your way with Tomedes at the helm.",
    link: "/russian-translation.php",
  },
  {
    heading: "Chinese",
    detail:
      "Boston boasts of a huge Chinese population of 25,921 Chinese residents. Reaching the Chinese demographic with English to Chinese could boost your business, with Chinese being a major business language worldwide. Tomedes is equipped with simplified and traditional Chinese variants so contact us today.",
    link: "/mandarin-chinese-translation",
  },
  {
    heading: "French",
    detail:
      "Another major business language, French is spoken by approximately 275 million people worldwide and is a popular language of Boston, MA, as well. To truly succeed in a French translation, translators must be versed in more than two languages, with French as a native language. Tomedes translators do just that.",
    link: "/french-translation.php",
  },
  {
    heading: "Arabic",
    detail:
      "There are 422 million speakers of Arabic in the world and about 200,000 in Massachusetts. Translating from Arabic to English and English to Arabic, or any other major language paired Arabic can make it easier for you to reach new international markets.",
    link: "/arabic-translation.php",
  },
];

export const TranslationInBoston = [
  {
    heading: "Diploma Translation Services",
    detail:
      "Do you need your diploma translated by a language professional? Certified translators in Boston can provide certified diplomas for all institutions and governmental bodies, for such applications as study abroad programs. Reach out today.",
    link: "/diploma-translation.php",
  },
  {
    heading: "Transcript Translation  Services",
    detail:
      "Not all transcripts are alike because transcript computations differ for each country. That's why you have to make sure that your transcripts are computed correctly, for specific regional requirements. Go with Tomedes for your transcript's translation.",
    link: "/transcript-translation-services",
  },
];
